import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantInfoService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGetMerchantDataQueryProps = {
	applicationId: string;
	tab: string;
};

const useGetMerchantDataQuery = ({
	applicationId,
	tab,
}: useGetMerchantDataQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["uwMerchantData", applicationId],
		() => merchantInfoService.getMerchantInformation(applicationId, tab),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!applicationId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetMerchantDataQuery;
